import { Upload, Progress } from "@aws-sdk/lib-storage";
import { HeadObjectCommand, S3Client } from "@aws-sdk/client-s3";
import api from "./api";
import { randomStr } from "./helper";

const typeMapper: any = {
  ".png": "image/png",
  ".jpeg": "image/jpeg",
  ".jpg": "image/jpeg",
  ".svg": "image/svg+xml",
  ".pdf": "application/pdf",
};

export interface S3Credentials {
  AccessKeyId: string;
  SecretAccessKey: string;
  SessionToken: string;
  Expiration: string;
}

let token: S3Credentials | undefined;

export async function upload(param: {
  file: File;
  filename?: string;
  prefix: string;
  onProgress?: (progress: Progress) => void;
}): Promise<string> {
  if (!token || token.Expiration <= new Date().toISOString()) {
    token = await api<S3Credentials>({
      method: "get",
      url: "/upload/token",
    });
  }

  const { prefix = "default", file, onProgress } = param;

  const ext = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

  const Bucket = `alfa-public-${process.env.REACT_APP_STAGE}`;
  const Key = `${prefix}/${param.filename || randomStr(12)}${ext}`;
  try {
    const parallelUploads3 = new Upload({
      client: new S3Client({
        region: process.env.REACT_APP_REGION,
        credentials: {
          accessKeyId: token.AccessKeyId,
          secretAccessKey: token.SecretAccessKey,
          sessionToken: token.SessionToken,
        },
      }),
      leavePartsOnError: false, // optional manually handle dropped parts
      params: {
        Body: param.file,
        Bucket,
        Key,
        CacheControl: "max-age=31536000",
        ContentType: typeMapper[ext],
        Metadata: {
          filename: encodeURIComponent(file.name),
        },
      },
    });

    parallelUploads3.on("httpUploadProgress", (progress) => {
      onProgress && onProgress(progress);
    });

    await parallelUploads3.done();
    return Key;
  } catch (e: any) {
    console.error(e);
    window.webApp.showMessage("error", e.message || JSON.stringify(e));
    throw e;
  }
}

export function unParseImageUrl(url: string): string {
  const l = new URL(url, window.origin);
  return l.pathname.replace(/\/?fit-in\/\w*\//g, "");
}

export async function getS3Filename(
  key: string,
  defaultValue?: string,
): Promise<string | undefined> {
  if (!token || token.Expiration <= new Date().toISOString()) {
    token = await api<S3Credentials>({
      method: "get",
      url: "/upload/token",
    });
  }
  const client = new S3Client({
    region: process.env.REACT_APP_REGION,
    credentials: {
      accessKeyId: token.AccessKeyId,
      secretAccessKey: token.SecretAccessKey,
      sessionToken: token.SessionToken,
    },
  });
  key = unParseImageUrl(key);
  const command = new HeadObjectCommand({
    Bucket: `alfa-public-${process.env.REACT_APP_STAGE}`,
    Key: key.indexOf("/") === 0 ? key.slice(1) : key,
  });
  try {
    const response = await client.send(command);
    return (
      (response.Metadata?.filename &&
        decodeURIComponent(response.Metadata?.filename)) ||
      defaultValue
    );
  } catch (error) {
    return defaultValue || key;
  }
}
